export default __webpack_public_path__ + "static/media/btn-zeroback-start-be_fr@2x.a9235fd3.png";